import { FeatureLimit } from '../types';

const REMEMBER_ME_KEY = '66862af9-cc6c-45d2-ab13-1c33202445a5';
const TOKEN = '5aea9b4c-751c-4bc3-a3ac-cfc5085e26cd';
const EXPIRE_DATE = '5eb00196-355e-4785-9cea-b8a7837cda49';
const ROLE = '19e2f689-52c2-48c6-a919-d6763d26f7b5';
const USER_ID = '14bed01e-4f7f-4bcc-ad12-55d8d27ad9e0';
const ORG_ID = 'ded9bbbf-0ef8-4d3e-8368-ea58dddee822';
const FEATURE_LIMIT = 'f6d940f7-5e02-4c97-bed2-ec9eae8ef361';
const IS_FEATURE_LIMIT_REACHED = '2bdd9055-3e8e-4e1c-81af-c34e78b6e52c';
const IS_ALL_FEATURE_LIMIT_REACHED = '97b6da60-2c4c-4a01-9a27-6d36880625d5';
const USER_TYPE = '9e86b1d7-2586-4c52-bf20-d666ffe49f0d';
const CHAT_SESSION_ID = 'b19974d8-afe6-47e1-93d7-ce753f2a2140';
const EMAIL = '10346fcc-6844-41ab-9efc-05fbd46d126d';
const NAME = '10346fcc-6844-41ab-9efc-05fbd46d5848';
const USER_ID_KEY1 = '14bed01e';
const USER_ID_KEY2 = '5aea9b4c';

export const getRememberMe = () => {
	const value = localStorage.getItem(REMEMBER_ME_KEY);
	if (value !== null) {
		return value;
	} else {
		return '2';
	}
};

export const setRememberMe = (key: string) => {
	localStorage.setItem(REMEMBER_ME_KEY, key);
};

export const getAccessToken = () => {
	return localStorage.getItem(TOKEN);
};

export const setAccessToken = (token: string) => {
	localStorage.setItem(TOKEN, token);
};

export const getUserRole = (): string => {
	const value = localStorage.getItem(ROLE);
	if (value) {
		return value;
	} else {
		return '0';
	}
};

export const setUserRole = (role: string) => {
	localStorage.setItem(ROLE, role);
};

export const getUserId = () => {
	const value = localStorage.getItem(USER_ID);
	if (value) {
		const id = value.replace(USER_ID_KEY1, '').replace(USER_ID_KEY2, '');
		return id;
	} else {
		return value;
	}
};

export const setUserId = (id: string) => {
	localStorage.setItem(USER_ID, `${USER_ID_KEY1}${id}${USER_ID_KEY2}`);
};

export const getAgencyId = () => {
	return localStorage.getItem(ORG_ID);
};

export const setAgencyId = (id: string) => {
	localStorage.setItem(ORG_ID, id);
};

export const getExpireTime = () => {
	return localStorage.getItem(EXPIRE_DATE);
};

export const setExpireTime = (type: string = 'admin') => {
	const currentDate = new Date();
	const expDate = new Date(
		currentDate.getTime() +
			(type === 'superAdmin' ? 1000 * 60 * 20 : 1000 * 60 * 60 * 48),
	);
	localStorage.setItem(EXPIRE_DATE, `${expDate.getTime()}`);
};

export const getFeatureLimit = () => {
	const storedFeatureLimit = localStorage.getItem(FEATURE_LIMIT);

	if (storedFeatureLimit && storedFeatureLimit !== 'undefined') {
		try {
			return JSON.parse(storedFeatureLimit);
		} catch (err) {
			console.error('Failed to parse feature limit status:', err);
			return null;
		}
	}

	return null;
};

export const setFeatureLimit = (list: FeatureLimit) => {
	localStorage.setItem(FEATURE_LIMIT, JSON.stringify(list));
};

export const getFeatureLimitStatus = () => {
	const storedValue = localStorage.getItem(IS_FEATURE_LIMIT_REACHED);

	if (storedValue && storedValue !== 'undefined') {
		try {
			return JSON.parse(storedValue);
		} catch (err) {
			console.error('Failed to parse feature limit status:', err);
			return null;
		}
	}

	return null;
};

export const setFeatureLimitStatus = (status: boolean) => {
	localStorage.setItem(IS_FEATURE_LIMIT_REACHED, JSON.stringify(status));
};

export const getAllFeatureLimitStatus = () => {
	const storedFeatureLimit = localStorage.getItem(
		IS_ALL_FEATURE_LIMIT_REACHED,
	);

	if (storedFeatureLimit !== null) {
		const parsedFeatureLimit = JSON.parse(storedFeatureLimit);
		return parsedFeatureLimit;
	}
};

export const setAllFeatureLimitStatus = (list: FeatureLimit) => {
	localStorage.setItem(IS_ALL_FEATURE_LIMIT_REACHED, JSON.stringify(list));
};

export const getUserType = () => {
	return localStorage.getItem(USER_TYPE);
};

export const setUserType = (type: string) => {
	localStorage.setItem(USER_TYPE, type);
};

export const getUserSessionId = () => {
	return localStorage.getItem(CHAT_SESSION_ID);
};

export const setUserSessionId = (id: string) => {
	localStorage.setItem(CHAT_SESSION_ID, id);
};

export const getUserEmail = () => {
	const email = localStorage.getItem(EMAIL);
	return email ? email : 'N/A';
};

export const setUserEmail = (mail: string) => {
	localStorage.setItem(EMAIL, mail);
};

export const getUserName = () => {
	const name = localStorage.getItem(NAME);
	return name ? name : 'N/A';
};

export const setUserName = (mail: string) => {
	localStorage.setItem(NAME, mail);
};

export const signOut = () => {
	localStorage.clear();
	window.location.href = '/login';
};
